module.exports = __webpack_public_path__ + "img/mars.85264c91.svg";